import React, { Component } from 'react';
import { Row, Col, Form } from 'react-bootstrap';

import SimpleSelections from '../suggestions/SimpleSelections';
import SucursalCatalogoManager from '../../../catalogs/managers/SucursalCatalogoManager';

class PersonalizarSucursalForm extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = { data: {}, show: false };
  }

  async componentDidMount() {
    const { data } = this.props;

    await SucursalCatalogoManager.boot();

    this.populateCatalog(data);
  }

  populateCatalog(data) {
    let sucursalesCatalogo = SucursalCatalogoManager.get();

    sucursalesCatalogo.map((item) => {
      return {
        label: `(${item.id}) ${item.sucursal}, ${item.ciudad}, ${item.codigo_postal}, Iva fronterizo: ${item.iva_fronterizo}`,
        value: item.id,
      };
    });

    this.setState({
      options: sucursalesCatalogo,
      show: (sucursalesCatalogo || []).length > 0,
      once: data.Emisor?.sucursal?.codigo_postal,
    });
  }

  handleOnSucursalChange = (selected) => {
    if (selected['id_sucursal'] ?? false) {
      const catalogo = SucursalCatalogoManager.get();

      const filterValue =
        catalogo.filter((item) => {
          return item.id === selected.id_sucursal.id;
        })[0] ?? undefined;

      this.onSucursalSelected(filterValue);
    } else {
      this.onSucursalSelected({});
    }
  };

  onSucursalSelected(data) {
    this.props.onChange({
      ...this.state.data,
      Emisor: {
        ...this.props.data.Emisor,
        sucursal: data,
      },
    });

    this.setState({
      once: false,
    });
  }

  getSucursal = (value) => {
    const catalogo = SucursalCatalogoManager.get();

    if (Array.isArray(catalogo)) {
      const item = catalogo.filter((item) => {
        return item.codigo_postal === value.codigo_postal;
      });

      return { ...(item[0] ?? {}) };
    }
  };

  render() {
    const { options = [], show, once } = this.state;
    const { sucursal = {} } = this.props.data?.Emisor;

    let selectedOption = undefined;

    if (once) {
      selectedOption = this.getSucursal(sucursal);
    }

    if (!show) {
      return <></>;
    }

    return (
      <div className="pb-4">
        <div>
          <strong className="text-black text-upper">Sucursal</strong>
        </div>

        <div className="section">
          <Row>
            <Col
              xs={12}
              sm={12}
              md={12}
              lg={12}
            >
              <div className="mt-3">
                <Form autoComplete="off">
                  <Row>
                    <Col>
                      <SimpleSelections
                        id="id_sucursal"
                        name="id_sucursal"
                        label="Seleccionar Sucursal"
                        placeholder={'Busca tu sucursal...'}
                        selected={selectedOption}
                        options={options}
                        onChange={this.handleOnSucursalChange}
                      />
                    </Col>
                  </Row>
                </Form>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default PersonalizarSucursalForm;
